/**
 *  Paging composition for contractSpecs
 */
import pagingComposition from '../../common/pagingTable/pagingComposition';
import contractSpecActionCreators from '../../../actions/contractSpecActionCreators';
export default pagingComposition('contractSpec', contractSpecActionCreators, {
  'Job Number': 'jobNumber',
  Phase: 'phase'
});